import axios from "axios";

const getDevicesControlLogAPI = async params => {
  let response = await axios({
    url: `/api/v2/command/task-logs`,
    method: "GET",
    params
  });
  return response.data;
};

export default getDevicesControlLogAPI;
